import type { BulkInviteStatus } from '@qse/api'

import { getBulkInviteStatusMeta } from './helpers'

/** Status pill shared by the tracking modal and the history table/details. */
export default function BulkInviteStatusChip({ status }: { status: BulkInviteStatus }) {
  const meta = getBulkInviteStatusMeta(status)

  return (
    <span className={`text-xs font-medium px-2.5 py-1 rounded ${meta.className}`}>
      {meta.label}
    </span>
  )
}
